import common from './common';
import uiv from './uiv';
import element from './element';
import catalog from './catalog';
import validate from './vee-validate';
import organization from './organization';

export default {
  cat4mro: {
    breadcrumbs: {
      root: 'CAT4MRO',
      search: 'Búsqueda',
    },
  },
  ...uiv,
  ...element,
  ...common,
  ...catalog,
  ...validate,
  ...organization,
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/index.js